import React from 'react';

interface ElementPreviewPanelProps {
  isOpen: boolean;
  onClose: () => void;
}

const ElementPreviewPanel: React.FC<ElementPreviewPanelProps> = ({
  isOpen,
  onClose
}) => {
  if (!isOpen) return null;

  return (
    <div className="preview-panel-overlay">
      <div className="preview-panel">
        <div className="preview-panel-header">
          <h3>Element Preview</h3>
          <button className="preview-panel-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="preview-panel-content">
          <p>Element preview functionality coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default ElementPreviewPanel; 